/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronDoubleDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.65 11 19 12.739 12 19l-7-6.261L6.35 11 12 16.054zm0-6L19 6.739 12 13 5 6.739 6.35 5 12 10.054z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronDoubleDown as ChevronDoubleDown };
